module.exports = __webpack_public_path__ + "img/13.21cc4475.png";